// extracted by mini-css-extract-plugin
export default {"navlink":"Header_navlink__sdaJW"};